import React from "react";

import { MobileNavArea, NavItemsUl } from "../styled/MobileNav.styled";

import { menuItems } from "../utils/routes";
import MobileNavItem from "./MobileNavItem";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";

function MobileNav () {
	return (
		<MobileNavArea>
			<NavItemsUl>
				{menuItems.map((item, i) => (
					<MobileNavItem {...item} key={`side-item-${item.title}-${i}`}/>
				))}
			</NavItemsUl>
		</MobileNavArea>
	)
}

export default withErrorBoundary(MobileNav, GeneralErrorBoundary);